/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_ProfileInputs */

const da_privacy_data_profile = /** @type {(inputs: Privacy_Data_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Om dig (frivilligt):** stilling, skole, kommune, fag, klassetrin og om vi må kontakte dig om feedback. Du udfylder det selv under Indstillinger → Konto og data, og du kan rette eller fjerne det, når du vil. Du kan bruge AImforA uden at udfylde det.`)
};

/** @type {(inputs: Privacy_Data_ProfileInputs) => LocalizedString} */
const en_privacy_data_profile = da_privacy_data_profile;

/**

* @param {Privacy_Data_ProfileInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_profile = /** @type {((inputs?: Privacy_Data_ProfileInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_ProfileInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_profile(inputs)
	return /** @type {LocalizedString} */ ("**Om dig (frivilligt):** stilling, skole, kommune, fag, klassetrin og om vi må kontakte dig om feedback. Du udfylder det selv under Indstillinger → Konto og data, og du kan rette eller fjerne det, når du vil. Du kan bruge AImforA uden at udfylde det.")
});